import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { BillingService } from '../services/billing.service';
import { hasAnyPermission } from '../utils/jwt.util';

/** Kampaniya / tizim xodimlari — mijoz ilovasidagi do'konlar va davomat yo'llari uchun emas */
const SYSTEM_STAFF_ROLES = ['SuperAdmin', 'Admin', 'Operator'];

export const permissionGuard: CanActivateFn = (route) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const billing = inject(BillingService);
  const role = auth.user()?.role;
  const requiredModule = route.data['requiredModule'] as string | undefined;

  if (route.data['forbidSystemRoles'] === true && role && SYSTEM_STAFF_ROLES.includes(role)) {
    void router.navigate(['/admin']);
    return false;
  }

  if (route.data['customerOnly'] === true && role !== 'Customer') {
    router.navigate(['/access-denied']);
    return false;
  }

  if (role === 'Customer' || role === 'SuperAdmin' || role === 'Admin' || role === 'Operator') {
    if (requiredModule && role === 'Customer') {
      return billing.getMyBilling().pipe(
        map((res) => {
          if (res.success && res.data.includedModules?.includes(requiredModule)) {
            return true;
          }
          router.navigate(['/access-denied']);
          return false;
        }),
        catchError(() => {
          router.navigate(['/access-denied']);
          return of(false);
        }),
      );
    }
    return true;
  }

  const permissions = route.data['permissions'] as string[] | undefined;
  if (!permissions?.length) {
    return true;
  }

  const token = auth.getAccessToken();
  const accountPermissions = auth.user()?.permissions;
  if (hasAnyPermission(token, role, permissions, accountPermissions)) {
    if (requiredModule) {
      return billing.getMyBilling().pipe(
        map((res) => {
          if (res.success && res.data.includedModules?.includes(requiredModule)) {
            return true;
          }
          router.navigate(['/access-denied']);
          return false;
        }),
        catchError(() => {
          router.navigate(['/access-denied']);
          return of(false);
        }),
      );
    }
    return true;
  }

  router.navigate(['/access-denied']);
  return false;
};
